var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardInquiry(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.065 29.467H2.935A2.947 2.947 0 0 1 0 26.53V7.47a2.947 2.947 0 0 1 2.935-2.936h28.13A2.947 2.947 0 0 1 34 7.47V26.53a2.947 2.947 0 0 1-2.935 2.936zM2.935 6.8a.669.669 0 0 0-.668.669V26.53a.669.669 0 0 0 .668.669h28.13a.669.669 0 0 0 .668-.669V7.47a.669.669 0 0 0-.668-.669H2.935z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.306 17.748a2.8 2.8 0 0 1-1.632-.521L.782 6.585l1.315-1.836L17 15.379a.544.544 0 0 0 .623 0l14.28-10.2 1.315 1.848-14.28 10.2a2.8 2.8 0 0 1-1.632.521z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M.635 27.196 11.122 12.7l1.836 1.329L2.47 28.524.635 27.196zM21.045 14.046l1.836-1.331L33.385 27.21l-1.836 1.33-10.504-14.494z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M2.5 6h29L17 16.5 2.5 6z",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardInquiry);
export default __webpack_public_path__ + "static/media/cardInquiry.6eba72f8d330c9b1c00e508533bd76be.svg";
export { ForwardRef as ReactComponent };